import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { FileResource } from 'app/shared/modules/folders/folders.types';
import { SharedResourcesService } from '../shared-resources.service';

@Injectable({
  providedIn: 'root',
})
export class SharedResourceRootFileResolver {
  constructor(private _sharedResourcesService: SharedResourcesService) {}

  resolve(): Observable<FileResource> {
    return this._sharedResourcesService.getRootFile();
  }
}
